import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

const StyledSortCont = styled.div`
  display: flex;
  align-items: center;
  ${media.mobile`
    padding-bottom: 19px;
  `}
  ${media.desktop`
    padding-bottom: 8px;
  `}
`;

const StyledLine = styled.div`
  width: 100%;
  height: 1px;
  margin-right: 7px;
  background-color: ${rgba(theme.color.white, 0.2)};
`;

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  min-width: fit-content;
`;

const StyledText = styled.span`
  margin-right: 4px;
  letter-spacing: 0.4px;
  ${typeStyle['font-12']};
`;

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  ${typeStyle['font-12']};
  letter-spacing: 0.4px;

  svg {
    width: 7px;
    margin-left: 4px;
  }
`;

export { StyledSortCont, StyledLine, StyledContent, StyledText, StyledButton };
